export default {
  photo_gallery: "Photo gallery",
}
